import ReturnsOptions from './ReturnsOptions';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsOptions);
